// extracted by mini-css-extract-plugin
export default {"pos-version":"POSSelect_pos-version__sADeY","select-box":"POSSelect_select-box__Br4wf"};